<script setup lang="ts">
definePageMeta({
    layout: false,
    middleware: ['entrance'],
    alias: [
        '/spil/:slug',
        '/spilleautomater/entrance/:slug',
    ],
    isEntrance: true,
})
</script>

<template>
    <GameEntrance />
</template>
